import { render, staticRenderFns } from "./EducationHome.vue?vue&type=template&id=0d6478b9&scoped=true"
import script from "./EducationHome.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6478b9",
  null
  
)

export default component.exports